/* eslint-disable react/jsx-no-useless-fragment */

import React from 'react';
import { wpLegacySchemaClass } from './Constants';

const stripLegacySchema = ({name, type, attribs}) =>
{
    if ( type !== 'tag' || name !== 'p' || !attribs?.class ) return null;
    const classNames = attribs.class.split(' ') || [];
    if ( !( classNames.includes( wpLegacySchemaClass ) ) ) return null;
    return <></>;
}
export default stripLegacySchema;
